import { SYS_SIZE_FIXED_1400, SYS_SIZE_FIXED_400, SYS_SIZE_FIXED_600, SYS_SIZE_FIXED_800 } from '../../tokens/sizing.generated.js';
import { SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_50 } from '../../tokens/spacing.generated.js';
import { SEM_TYPOGRAPHY_FORMS_LABEL } from '../../tokens/typography.generated.js';
import { getTypographyStyles } from '../../utils/index.js';
import styled, { css } from 'styled-components';
import { FormMessage } from '../form-message/index.js';
import { SEM_BORDER_RADIUS_FORMS_MAX } from '../../tokens/border-radius.generated.js';
import {} from './index.js';
export const StyledLabel = styled.label `
  color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.text.disabled
    : props.theme.sem.color.forms.foreground.text.default};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL)}
  display: flex;
  gap: ${SYS_SPACE_FIXED_150};
  align-items: center;
  ${(props) => props.labelPosition === 'leading' &&
    css `
      justify-content: space-between;
    `}
`;
export const StyledContainer = styled.div `
  display: inline-flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_150};
`;
export const StyledPill = styled.div `
  overflow: hidden;
  position: relative;
  cursor: pointer;
  flex-shrink: 0;
  border-radius: ${SEM_BORDER_RADIUS_FORMS_MAX};
  height: ${SYS_SIZE_FIXED_800};
  width: ${SYS_SIZE_FIXED_1400};
  background-color: ${(props) => props.theme.cmp.color.forms.toggle.inactive.surface.default};
  transition-property: background-color;
  // TODO: token missing;
  transition-duration: 250ms;
  transition-timing-function: ease;

  &::before {
    z-index: 1;
    display: block;
    position: absolute;
    content: '';
    width: ${SYS_SIZE_FIXED_600};
    height: ${SYS_SIZE_FIXED_600};
    border-radius: ${SEM_BORDER_RADIUS_FORMS_MAX};
    top: 50%;
    left: ${SYS_SPACE_FIXED_50};
    transform: translate(0, -50%);
    background-color: ${(props) => props.theme.cmp.color.forms.toggle.inactive.surface.handle.default};
    transition-property: transform;
    // TODO: token missing;
    transition-duration: 250ms;
    transition-timing-function: ease;
  }

  &::after {
    z-index: 0;
    display: block;
    position: absolute;
    content: '';
    top: 50%;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("data:image/svg+xml,%0A%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='IconOff'%3E%3Cpath id='zero' fill-rule='evenodd' clip-rule='evenodd' d='M8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5ZM8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6Z' fill='%23666666'/%3E%3C/g%3E%3C/svg%3E%0A");
    transform: translate(0, -50%);
    right: ${SYS_SPACE_FIXED_50};
    height: ${SYS_SIZE_FIXED_400};
    width: ${SYS_SIZE_FIXED_400};
    transition-property: transform, background-image, right;
    // TODO: token missing;
    transition-duration: 250ms;
    transition-timing-function: ease;
  }
`;
export const StyledFormMessage = styled(FormMessage) `
  margin-left: ${(props) => props.labelPosition === 'trailing'
    ? `calc(${SYS_SIZE_FIXED_1400} + ${SYS_SPACE_FIXED_150})`
    : 0};

  ${(props) => props.labelPosition === 'leading' &&
    css `
      padding-right: calc(${SYS_SIZE_FIXED_1400} + ${SYS_SPACE_FIXED_150});
    `}
`;
export const StyledInput = styled.input `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  white-space: nowrap;
  width: 1px;
  position: absolute;
  opacity: 0;
  pointer-events: none;

  &:checked + ${StyledPill} {
    background-color: ${(props) => props.theme.cmp.color.forms.toggle.active.surface.default};

    &::before {
      transform: translate(100%, -50%);
    }

    &::after {
      right: 34px;
      background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='IconOn'%3E%3Cpath id='one' opacity='0.9' d='M7 4H8V12H7V4Z' fill='white'/%3E%3C/g%3E%3C/svg%3E");
    }
  }

  &:focus-visible + ${StyledPill} {
    outline: 2px solid Highlight;
    outline: 2px solid -webkit-focus-ring-color;
    outline-style: auto;
  }

  &:focus:not(:checked) + ${StyledPill} {
    background-color: ${(props) => props.theme.cmp.color.forms.toggle.inactive.surface.interactive};
  }

  &:not(:disabled):not(:checked) + ${StyledPill}:hover {
    background-color: ${(props) => props.theme.cmp.color.forms.toggle.inactive.surface.interactive};
  }

  &:disabled + ${StyledPill} {
    cursor: not-allowed;
    background-color: transparent;

    &::before {
      opacity: 0.7;
    }

    &::after {
      background-color: ${(props) => props.theme.cmp.color.forms.toggle.inactive.surface.disabled};
      background-image: none;
      height: 100%;
      width: 100%;
      right: 0;
      opacity: 0.5;
    }
  }

  &:disabled:checked + ${StyledPill} {
    background-color: ${(props) => props.theme.cmp.color.forms.toggle.active.surface.disabled};

    &::after {
      display: none;
    }
  }
`;
//# sourceMappingURL=index.styles.js.map